import React from 'react';

import { withScoutTheme } from '@/components/ThemeContext/ThemeContext';

export interface SaveSuccessProps {
  title: string;
  message: string;
  wcag?: boolean;
}

const SaveSuccess = ({ title, message, wcag = false }: SaveSuccessProps) => {
  if (wcag) {
    return (
      <section aria-labelledby="success-heading" className="wcag-success-content">
        <h2 id="success-heading">{title}</h2>
        <div className="wcag-success-body">
          <p>{message}</p>
        </div>
      </section>
    );
  }

  return (
    <div className="container">
      <h3>{title}</h3>
      <p className="success-info">{message}</p>
    </div>
  );
};

export default withScoutTheme(SaveSuccess);
